const PRODI_MAHASISWA = {
  "S1 Ilkom Reguler": "S1 Ilkom Reguler",
  "S1 Ilkom Paralel": "S1 Ilkom Paralel",
  "S1 Ilkom KI": "S1 Ilkom KI",
  "S1 SI Reguler": "S1 SI Reguler",
  "S1 SI Paralel": "S1 SI Paralel",
  "S1 SI Ekstensi": "S1 SI Ekstensi",
  "S2 MIK": "S2 MIK",
  "S2 MTI": "S2 MTI",
  DIK: "DIK",
};

const PRODI_MAHASISWA_NUMBERED = {
  1: "S1 Ilkom Reguler",
  2: "S1 Ilkom Paralel",
  3: "S1 Ilkom KI",
  4: "S1 SI Reguler",
  5: "S1 SI Paralel",
  6: "S1 SI Ekstensi",
  7: "S2 MIK",
  8: "S2 MTI",
  9: "DIK",
};

export { PRODI_MAHASISWA, PRODI_MAHASISWA_NUMBERED };
